import { Component, OnInit } from '@angular/core';
import { ReportBase } from '../report.base';
import { ReportsService } from '../../../../services';
import { AppState, Store, FinancialsReportUserListItem, FinancialsReport } from '../../../../store';
import * as _ from 'lodash';

@Component({
  selector: 'app-financials-report',
  templateUrl: './financials-report.component.html',
  styleUrls: ['./financials-report.component.css']
})
export class FinancialsReportComponent extends ReportBase implements OnInit {

  report: FinancialsReport;
  controls = [];

  constructor(
    public service: ReportsService,
    public store: Store<AppState>
  ) {
    super(service, store);
  }

  ngOnInit() {
    this.pullData('getFinancialsReportData');
  }

  getBalance(item: FinancialsReportUserListItem) {
    return !!item.removedDate ? 0 : item.originalAmount - item.paid - item.discountAmount - item.scholarshipAmount - item.creditAmount;
  }

  updateControls() {
    this.controls = [
      { name: 'name', type: 'text', title: 'Name' },
      { name: 'gender', type: 'select', title: 'Gender', options: [{ text: 'Male', value: 'm' }, { text: 'Female', value: 'f' }] },
      {
        name: 'teamGroup', type: 'select', title: 'Team', options: _.orderBy(this.getSearchOptions('teamGroup'), ['text','value'], ['asc', 'desc'])
      },
      { name: 'feeName', type: 'select', title: 'Fee', options: this.getSearchOptions('feeName') }
    ];

    super.updateControls();
  }

  private getSearchOptions(field: string) {
    //debugger
    return _.uniq(this.report.list.map(l => l[field])).map(t => ({
      text: t, value: t
    }));
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/clubprogram-reports/components/financials-report/financials-report.component.ts